export default __webpack_public_path__ + "static/media/st4.94ca0241.jpg";